import { API_BASE_URL } from '../config/environment';

export const getInterclubFeatureToggles = async (interclubId, token) => {
  const response = await fetch(`${API_BASE_URL}/interclub-feature-toggles?interclubId=${encodeURIComponent(interclubId)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to load interclub feature toggles');
  }

  return response.json();
};

export const updateInterclubFeatureToggles = async (interclubId, payload, token) => {
  const response = await fetch(`${API_BASE_URL}/interclub-feature-toggles/${interclubId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to update interclub feature toggles');
  }

  return response.json();
};

export const getPublicInterclubFeatureToggles = async (interclubId) => {
  const response = await fetch(
    `${API_BASE_URL}/interclub-feature-toggles/public?interclubId=${encodeURIComponent(interclubId)}`
  );
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to load interclub feature toggles');
  }
  return response.json();
};
